module.exports = __webpack_public_path__ + "static/img/1.2c905a7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/supply/1.png
// module id = qdAA
// module chunks = 1